import { LogFile } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import { AxiosResponse } from 'axios';
import { LogType } from '../Types/Enums';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const complianceService = {
    getLogFiles: async (
        type: LogType,
        page: number,
        itemsPerPage: number,
        query?: string | null,
    ): Promise<{ data: { data: LogFile[]; total: number } }> => {
        return requestClient.get(`${resolveDemo() ? '/demo' : ''}/log-files/get`, {
            params: {
                type,
                page,
                itemsPerPage,
                query,
            },
        });
    },

    downloadLogFiles: async (type: LogType, filenames?: string, from?: string, to?: string): Promise<AxiosResponse> => {
        return requestClient.get('/log-files/download', {
            params: { type, filenames, fromDateTime: from, toDateTime: to },
            responseType: 'blob',
        });
    },
};
